import script from "./EmpBasicInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpBasicInfo.vue?vue&type=script&setup=true&lang=ts"

import "./EmpBasicInfo.vue?vue&type=style&index=0&id=e79dd4c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e79dd4c4"]])

export default __exports__